// extracted by mini-css-extract-plugin
var _1 = "ExternalPostsView-module__animateUploadProgressBarWidth--FXDyU";
var _2 = "ExternalPostsView-module__animatedBackground--PVTOQ";
var _3 = "ExternalPostsView-module__container--esTej";
var _4 = "ExternalPostsView-module__mainTitle--ohBBS";
var _5 = "ExternalPostsView-module__titleLogo--X08NQ";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "mainTitle", _5 as "titleLogo" }
